module.exports = __webpack_public_path__ + "img/Arabic-08.d68f962e.jpg";